<div class="main-content">
  <div class="container-fluid mt-4">
    <div class="text-center">
      <button
        class="btn btn-icon btn-outline-primary"
        [ngbTooltip]="showFilter ? 'Hide and reset filters' : 'Show Filters'"
        placement="bottom"
        (click)="toggleFilter()"
      >
        <fa-icon [icon]="['fal', 'filter']"></fa-icon>
      </button>
    </div>

    <div class="row">
      <div *ngIf="showFilter" class="col-md-12">
        <app-dashboard-filter [labels]="dashboard?.labels" (onUpdate)="onFilterUpdated($event)"></app-dashboard-filter>
      </div>

      <ng-container *ngIf="dashboard?.widgets">
        <div
          *ngFor="let c of dashboard.widgets"
          homeWidget
          [class]="classFor(c)"
          [component]="c.component"
          [settings]="c.settings"
          [column]="w"
          [keyDate]="keyDate"
        ></div>
      </ng-container>
    </div>
  </div>
</div>
